require(["common/formUtils", "common/spinner"],
    function (formUtils, spinner) {

        const blogForm = "#frmBlogSubscribe";
        var firstNamePlaceholder = "";
        var lastNamePlaceholder = "";
        const spinnerSelector = "#blog-signup-spinner";
        const blogMessage = "#blog-message";
        const blogSubscribeBtnSelector = "#btnBlogSubscribe";

        function init() {   
            var form = $(blogForm);
            setPlaceholders(form);
            getDefaultPlaceholderValues(form);           
            $(blogSubscribeBtnSelector).off("click").on("click", function () {                
                var isValid = validateForm();
                if (isValid) {
                    subscribe();
                }
            });            
        } 

        function validateForm() {
            removePlaceholders();
            var form = $(blogForm);
            var isValid = form.valid();
            $.validator.unobtrusive.parse(form);
            setPlaceholders(form);
            return isValid;
        }

        function subscribe() {
            var subscribeData = {
                FirstName: $("#FirstName").val(),
                LastName: $("#LastName").val(),
                Email: $("#useremail").val()
            };
            formUtils.useToken(subscribeData);
            spinner.show(spinnerSelector);   
            $(blogSubscribeBtnSelector).attr('disabled', true);
            $.ajax({
                type: "POST",
                url: "/customapi/Account/BlogSubscribe",
                dataType: "json",
                data: subscribeData,
                success: function (data) {
                    if (data.status === "OK") {
                        if (data.message) {
                            // display message
                            setBlogFormElementsVisible(false);
                            $(blogMessage).html(data.message);
                            spinner.hide(spinnerSelector);
                        }
                    } else {        
                        $(blogMessage).removeClass("d-none");
                        $(blogMessage).addClass("error").html(data.message);
                        validateForm();
                        spinner.hide(spinnerSelector);
                    }
                },
                error: function (jq, status, errorThrown) {                 
                    $(blogMessage).removeClass("d-none");
                    $(blogMessage).addClass("error").html(status + ". " + errorThrown);
                    spinner.hide(spinnerSelector);
                },
                complete: function () {
                    
                }
            });
        }

        function setBlogFormElementsVisible(show) {
            var cssClass = "d-none";
            if (show) cssClass = "";
            $("#frmBlogSubscribe .modal-body").addClass(cssClass);
            $(blogMessage).removeClass(cssClass);
            $(".modal-footer").addClass(cssClass);
        }

        function getDefaultPlaceholderValues(form) {            
            firstNamePlaceholder = form.data("firstname");
            lastNamePlaceholder = form.data("lastname");
        }

        function setPlaceholders(form) {           
            if ($("#FirstName").val() == "")
                $("#FirstName").attr("placeholder", form.data("firstname")).val("").focus().blur();
            if ($("#LastName").val() == "")
                $("#LastName").attr("placeholder", form.data("lastname")).val("").focus().blur();           
        }

        function removePlaceholders() {      
            if ($("#FirstName").val() == firstNamePlaceholder)
                $("#FirstName").attr("placeholder", "").val("").focus().blur();
            if ($("#LastName").val() == lastNamePlaceholder)
                $("#LastName").attr("placeholder", "").val("").focus().blur();
        }

        init();
    });

define("BlogSignUp/main", function(){});

